import { Col, Row } from '@helvetia/components/layout'
import { css, styled } from '@helvetia/components/theme'
import { VerticalSpaceProps } from '@helvetia/components/theme/css'
import { Size, sizes } from '@helvetia/components/theme/size'
import { rem } from 'polished'
import {
  horizontalMarginsCss,
  verticalMarginsCss,
} from '@helvetia/components/theme/css'

export const TitleWrapper = styled(Col)`
  flex-basis: 0;
  justify-content: flex-end;
  justify-self: flex-end;
  align-content: center;
  ${p =>
    p.tablet &&
    !p.desktop &&
    css`
      margin-top: ${rem(Size.m)};
    `}
`
export const ButtonGroup = styled(Row)`
  width: 100%;
  display: inline-flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
`
export const ButtonWrapper = styled(Col)`
  width: 50%;
  flex-grow: 1;
`
export const Spacer = styled.div.attrs({})<VerticalSpaceProps>`
  content: '';
`
export const Image = styled.img`
  ${horizontalMarginsCss};
  ${verticalMarginsCss};
  display: inline-block;
  max-height: 80%;
  width: 90%;
  margin-top: ${rem(sizes.xxxs)};
  margin-bottom: ${rem(sizes.xxxs)};
`
export const QuestionWrapper = styled.div`
  margin-top: ${rem(sizes.m)};
  margin-bottom: ${rem(sizes.s)};
`
